import { useContext, useEffect, useState } from "react";
import { getClientHoldings, getClientProfile } from "../../services/clientService";
import { thousandSeparator } from '../../util/thousandSeperator';
import { PositionContext, PendingContext, DeleteModalContext, ThemeContext, ClientProfileContext, ClientHoldingContext, SwalContext, SettingViewContext } from '../../layout/BaseLayout';
import FloatingPnLTotal from "./floatingPnLTotal";
import PositionTr from "./positionTr";
import PendingTr from "./pendingTr";
import TradeComponent from "./tradeComponent";
import SymbolDetail from "../Home/SymbolDetail";
import SinglePositionSummary from "./singlePositionSummary";
import { deletePendingOrderAPI, deletePositionItem } from "../../services/tradeService";
import { globalRef } from "./globalRef";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";


const Trade = () => {
    let toast = useContext(ThemeContext);
    let allpos = useContext(PositionContext);
    let allpending = useContext(PendingContext);
    let deleteData = useContext(DeleteModalContext);
    let clientProfileContxt = useContext(ClientProfileContext);
    let clientHoldingContxt = useContext(ClientHoldingContext);
    let Swal = useContext(SwalContext);
    Swal = withReactContent(Swal);
    let navigate = useNavigate();
    let [settingView, setSettingView] = useContext(SettingViewContext)

    const [tradeViewIndex, setTradeViewIndex] = useState(0);
    const [holdingDetails, setHoldingDetails] = useState({});
    const [clientDetails, setClientDetails] = useState({});
    const [userAccData, setUserAccData] = useState(null);
    const [posList, setPosList] = useState([]);
    const [pendingList, setPendingList] = useState([]);
    const [freeMargin, setFreeMargin] = useState(null);
    const [equity, setEquity] = useState(null);
    const [fpnl, setFpnl] = useState(null);
    const [clickedSymbole, setClickedSymbole] = useState(null);
    const [optionOpen, setOptionOpen] = useState(false);
    const [positionBulkOptionOpen, setPositionBulkOptionOpen] = useState(false);
    const [pendingBulkOptionOpen, setPendingBulkOptionOpen] = useState(false);
    const [view, setView] = useState('');
    const [disableDeleteBtn, setDisableDeleteBtn] = useState(false);
    const token = sessionStorage.getItem('token');
    const [sortingOpen, setSortingOpen] = useState(false);
    const [isPositionChecked, setIsPositionChecked] = useState(false);
    const [sortType, setSortType] = useState(JSON.parse(localStorage.getItem('curLogin'))?.sortType || '')
    const [selectedPositionItems, setSelectedPositionItems] = useState([]);
    const [selectedPendingItems, setSelectedPendingItems] = useState([]);
    const [updatedBal, setUpdatedBal] = useState(0);
    const [limitOrStopLength, setLimitOrStopLength] = useState({
        limitOrderLength: [],
        stopOrderLength: []
    })


    useEffect(() => {
        if (!positionBulkOptionOpen || !pendingBulkOptionOpen) {
            globalRef.dicPnl = {};
        }
        if (positionBulkOptionOpen || pendingBulkOptionOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

    }, [positionBulkOptionOpen, pendingBulkOptionOpen])

    useEffect(() => {
        if (!!token) {
            const userAuthData = JSON.parse(localStorage.getItem('curLogin'));
            setUserAccData({ ...userAuthData });
            // getClientHoldingDetails(userAuthData.loginid);
            // getClientPrfl();
        } else {
            // window.location.href = '/setting';
        }
    }, [])

    useEffect(() => {
        setSettingView('main')
    }, [])

    useEffect(() => {
        setClientDetails({ ...clientProfileContxt });
    }, [clientProfileContxt])
    useEffect(() => {
        setHoldingDetails({ ...clientHoldingContxt });
    }, [clientHoldingContxt, allpos])


    useEffect(() => {
        if (!!allpos) {
            setPosList([...allpos]);
        } else {
            setPosList([]);
        }
    }, [allpos])

    useEffect(() => {
        if (!!allpending) {
            setPendingList([...allpending]);
            const filteredLimitOrder = allpending?.filter((item) => ["buylimit", "selllimit"]?.includes(item?.orderType.toLowerCase())).map((itm) => itm.orderId);
            const filterStopOrder = allpending?.filter((item) => ["buystop", "sellstop"]?.includes(item?.orderType.toLowerCase())).map((itm) => itm.orderId);
            setLimitOrStopLength({ stopOrderLength: filterStopOrder, limitOrderLength: filteredLimitOrder })
        } else {
            setPendingList([]);
        }
    }, [allpending])

    // const getClientHoldingDetails = (id) => {
    //     getClientHoldings(id).then((res) => {
    //         if (res.isSuccess) {
    //             res.data.balance = res.data.uplineAmount + res.data.uplineCommission;
    //             setHoldingDetails(res?.data)
    //         }
    //     })
    // }


    // const getClientPrfl = (d) => {
    //     getClientProfile().then((res) => {
    //         if (res.isSuccess) {
    //             setClientDetails(res?.data)
    //             localStorage.setItem('clientDetails', JSON.stringify(res?.data));
    //         }
    //     })
    // }

    const onRemovePendingClick = () => {
        deleteData({ openDeleteModal: true, customMessage: "you want to delete?!", callBackFunction: deletePendingOrder, deleteModalItem: clickedSymbole.orderId });
        setClickedSymbole(null); setOptionOpen(false); setView('');
    }

    const deletePendingOrder = (id) => {
        deleteData({ openDeleteModal: false, customMessage: "", callBackFunction: null, deleteModalItem: null });
        setDisableDeleteBtn(true);
        if (!disableDeleteBtn) {
            let param = {
            };
            param["orderIds"] = [];
            param["orderIds"].push(id);
            param["deviceDetail"] = {
                "clientIP": userAccData['localIP'],
                "device": "web",
                "reason": "client"
            };

            deletePendingOrderAPI(param).then((res) => {
                if (!!res && res.isSuccess) {
                    setDisableDeleteBtn(false);
                    if (!!res.isSuccess) {
                        toast.success(res?.successMessage);

                    } else {
                        toast.error(res?.exception?.message);
                    }
                }
            }).catch(error => {
                setDisableDeleteBtn(false);
                toast.error(error);
            });
        }
    }

    const onTradeCloseModifyClick = (modify = false) => {
        if (modify) {
            let clcked = clickedSymbole;
            clcked['modify'] = true;
            setClickedSymbole({ ...clcked });
        }
        setOptionOpen(false);
        setView('');
        setTradeViewIndex(1);
    }

    const navigateOnChart = (sym) => {
        let cliked = { ...clickedSymbole }
        setView('chartview');
        navigate('/chart', { state: { symbol: !!sym ? sym : cliked } });
    }

    // let filteredlistData = [];
    let listData = [...posList];
    if (sortType === 'asc') {
        listData = listData.sort((a, b) => a.symbolName.localeCompare(b.symbolName));
        // filteredlistData = filteredlistData.sort((a, b) => a.symbolName.localeCompare(b.symbolName));
    } else if (sortType === 'dsc') {
        listData = listData.sort((a, b) => b.symbolName.localeCompare(a.symbolName));
        // filteredlistData = filteredlistData.sort((a, b) => b.symbolName.localeCompare(a.symbolName));
    }

    const handlePositionCheckedChange = () => {
        setIsPositionChecked(!isPositionChecked);
        if (isPositionChecked) {
            setSelectedPositionItems([]);
        }
    }

    const handlePositionRowSelection = (id) => {
        setOptionOpen(false);
        const isSelected = selectedPositionItems.includes(id);
        const updatedSelectedItems = isSelected ? selectedPositionItems?.filter((itm) => itm !== id) : [...selectedPositionItems, id];
        setSelectedPositionItems(updatedSelectedItems);
    }

    const handlePendingRowSelection = (id) => {
        setOptionOpen(false);
        const isSelected = selectedPendingItems.includes(id);
        const updatedSelectedItems = isSelected
            ? selectedPendingItems.filter((item) => item !== id)
            : [...selectedPendingItems, id];
        setSelectedPendingItems(updatedSelectedItems);
    }

    const selectMethodForClosePosition = (type) => {
        switch (type) {
            case "selected":
                if (selectedPositionItems.length === 0) {
                    toast.warn("No position selected for deletion!");
                    setPositionBulkOptionOpen(false);
                    return;
                } else {
                    setPositionBulkOptionOpen(false);
                    deletePosItem(selectedPositionItems);
                }
                break;
            case "closeall":
                const allIds = posList?.map((item) => item.id);
                setSelectedPositionItems(allIds);
                setPositionBulkOptionOpen(false);
                deletePosItem(allIds);
                break;
            case "closeprofitable":
                const profitIds = Object.values(globalRef.dicPnl).filter((item) => item.fpnl > 0).map((item) => item.id);
                if (profitIds.length > 0) {
                    setSelectedPositionItems(profitIds);
                    setPositionBulkOptionOpen(false);
                    deletePosItem(profitIds);
                } else {
                    setSelectedPositionItems([]);
                    setIsPositionChecked(false);
                    toast.warn("No profitable positions available for deletion!");
                }
                break;
            case "closelosing":
                const lossingIds = Object.values(globalRef.dicPnl).filter((item) => item.fpnl < 0).map((item) => item.id);
                if (lossingIds.length > 0) {
                    setSelectedPositionItems(lossingIds);
                    setPositionBulkOptionOpen(false);
                    deletePosItem(lossingIds);
                } else {
                    setSelectedPositionItems([]);
                    setIsPositionChecked(false);
                    toast.warn("No lossing positions available for deletion!");
                }
                break;
            default:
                setSelectedPositionItems([]);
                setIsPositionChecked(false);
                break;
        }
    }

    const deletePosItem = (ids) => {
        const body = {
            positionIds: ids,
            deviceDetail: {
                clientIP: userAccData['localIP'],
                device: "web",
                reason: "client",
            },
        }

        deletePositionItem(body).then((res) => {
            if (res.isSuccess) {
                toast.success(res?.successMessage);
                setIsPositionChecked(false);
                globalRef.dicPnl = {};
            } else {
                toast.error(res?.exception?.message);
            }
        })
    }

    const selectMethodForClosePendingOrder = (type) => {
        switch (type) {
            case "deleteall":
                const allIds = pendingList?.map((item) => item?.orderId);
                setSelectedPendingItems(allIds);
                setPendingBulkOptionOpen(false);
                deletePendingItem(allIds);
                break;
            case "deletelimit":
                const filteredLimitOrder = pendingList?.filter((item) => ["buylimit", "selllimit"]?.includes(item?.orderType.toLowerCase())).map((itm) => itm.orderId);
                if (filteredLimitOrder?.length > 0) {
                    setSelectedPendingItems(filteredLimitOrder);
                    deletePendingItem(filteredLimitOrder);
                    setPendingBulkOptionOpen(false);
                } else {
                    toast.warn("No Pending order available for deletion!");
                }
                break;
            case "deletestop":
                const filterStopOrder = pendingList?.filter((item) => ["buystop", "sellstop"]?.includes(item?.orderType.toLowerCase())).map((itm) => itm.orderId);
                if (filterStopOrder?.length > 0) {
                    setSelectedPendingItems(filterStopOrder);
                    deletePendingItem(filterStopOrder);
                    setPendingBulkOptionOpen(false);
                } else {
                    toast.warn("No Pending order available for deletion!");
                }

            default:
                setSelectedPendingItems([]);

        }
    }

    const deletePendingItem = (ids) => {
        let body = {
            "orderIds": ids,
            "deviceDetail": {
                clientIP: userAccData['localIP'],
                device: "web",
                reason: "client",
            }
        }

        deletePendingOrderAPI(body).then((res) => {
            if (res?.isSuccess) {
                if (!!res.isSuccess) {
                    toast.success(res?.successMessage);
                    globalRef.dicPnl = {};
                } else {
                    toast.error(res?.exception?.message);
                }
            }
        }).catch(error => {
            toast.error(error);
        });
    }

    useEffect(() => {
        if (!!holdingDetails) {
            const updtBal = holdingDetails?.balance + holdingDetails?.newBalance;
            setUpdatedBal(updtBal)
        }
    }, [holdingDetails])

    return (
        <>
            {/* TRADE listing START */}
            {tradeViewIndex === 0 &&
                <div className="" >
                    {/* HEADER START */}
                    <div className="header"
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setSortingOpen(false);
                            }
                        }}>
                        <div className="header-box">
                            <div className="himg"></div>
                            <FloatingPnLTotal orderposition={posList} clientDetails={clientDetails[0]?.clientDetails} holdingDetails={holdingDetails} setFreeMargin={(vl) => setFreeMargin(vl)} setEquity={(vl) => setEquity(vl)} />
                            <div className="himg"><img src={"/images/plus.svg"} alt="" onClick={() => {
                                if (!!token) {
                                    setTradeViewIndex(1);
                                    setSettingView("tradecom");
                                } else {
                                    Swal.fire({
                                        showConfirmButton: true,
                                        text: "Please login",
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: 'Ok'
                                    });
                                }
                            }
                            } /></div>
                        </div>
                        <div>
                            <table className="table w-100  whitespace mb-0 tradetb">
                                <tbody>
                                    <tr>
                                        <td className="w-50 font-12 f-arial ">Balance: </td>
                                        <td className={`w-50 font-12 font-bold text-right f-arial-bold ${holdingDetails?.balance < 0 ? "text-danger" : ""}`}>{!!holdingDetails ? (!!updatedBal ? thousandSeparator(updatedBal.toFixed(2)) : '0.00') : '0.00'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50 font-12 f-arial">Equity: </td>
                                        <td className="w-50 font-12 font-bold text-right f-arial-bold">{!!equity ? thousandSeparator(equity.toFixed(2)) : '0.00'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50 font-12 f-arial">Credit: </td>
                                        <td className="w-50 font-12 font-bold text-right f-arial-bold">{!!holdingDetails && !!holdingDetails.creditAmount ? thousandSeparator(holdingDetails.creditAmount.toFixed(2)) : '0.00'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50 font-12 f-arial">Margin: </td>
                                        <td className="w-50 font-12 font-bold text-right f-arial-bold">{!!holdingDetails && !!holdingDetails.occupiedMarginAmount ? thousandSeparator(holdingDetails.occupiedMarginAmount.toFixed(2)) : '0.00'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-50 font-12 f-arial">Free Margin: </td>
                                        <td className="w-50 font-12 font-bold text-right f-arial-bold">{!!freeMargin ? thousandSeparator(freeMargin.toFixed(2)) : (!!holdingDetails && !!holdingDetails.freeMarginAmount ? thousandSeparator(holdingDetails.freeMarginAmount.toFixed(2)) : '0.00')}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* HEADER END */}
                    {!!posList && posList?.length > 0 &&
                        <div className="align-items-center bgmain d-flex font-12 font-bold justify-content-between mb-0 mt-0 text-black pr-3">
                            <div className="d-flex">
                                <span className="mtext font-12 text-black font-bold pl-2" >
                                    <div className="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input "
                                            id="customSwitch1"
                                            checked={isPositionChecked}
                                            onChange={handlePositionCheckedChange}
                                        />
                                        <label
                                            className="custom-control-label mtext font-12 text-black font-bold pl-2"
                                            htmlFor="customSwitch1"
                                        >
                                            Positions
                                        </label>
                                    </div>
                                </span>
                                <span className="himg pl-2" >{<span onClick={() => { setSortingOpen(!sortingOpen) }} className="icon quotes-icon active align-self-center" />}</span>
                            </div>
                            <span className="himg ml-2" onClick={() => setPositionBulkOptionOpen(true)}><img className="" src="/images/three-dots.svg" /></span>
                        </div>
                    }

                    {sortingOpen && <div className="trade-sort-context">
                        <div onClick={() => { setSortType('asc'); setSortingOpen(!sortingOpen) }}><input type="radio" checked={sortType === "asc"} /> A to Z</div>
                        <hr />
                        <div onClick={() => { setSortType('dsc'); setSortingOpen(!sortingOpen) }}><input type="radio" checked={sortType === "dsc"} /> Z to A</div>
                        <hr />
                        <div onClick={() => { setSortType(''); setSortingOpen(!sortingOpen) }}><input type="radio" checked={sortType === ""} /> Default</div>

                    </div>}
                    {/* MIDDLE START */}
                    {!!posList && posList?.length > 0 &&
                        <>
                            <div className="middle bgmain mt-0">
                                <div className="settingbox border-0">
                                    <table className="table w-100  whitespace mb-0 tradetb">
                                        <tbody>
                                            {
                                                listData.map((itm, indx) => {
                                                    return (
                                                        <PositionTr key={itm.id} positionItem={itm} index={indx} selectSymbole={(im) => { setClickedSymbole(im); setView('main'); setOptionOpen(true); }} isPositionChecked={isPositionChecked} isChecked={selectedPositionItems.includes(itm.id)} onRowClick={handlePositionRowSelection} />
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    }

                    {!!pendingList && pendingList.length > 0 &&
                        <>
                            <div className="mt-0 font-12 d-flex justify-content-between text-black font-bold mb-0 bgmain pr-3">
                                <span className="mtext font-12 text-black font-bold pl-2" >
                                    Pending
                                </span>
                                <span className="himg ml-2" onClick={() => setPendingBulkOptionOpen(true)}><img className="" src="/images/three-dots.svg" /></span>
                            </div>
                            <div className="middle bgmain mt-0">
                                <div className="settingbox border-0">
                                    <table className="table w-100  whitespace mb-0 tradetb">
                                        <tbody>
                                            {
                                                pendingList.map((itm, indx) => {
                                                    return (
                                                        <PendingTr key={itm.orderId} positionItem={itm} index={indx} selectSymbole={(im) => { setClickedSymbole(im); setView('main'); setOptionOpen(true); }} />
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    }

                </div>
            }
            {view === 'main' && Object.keys(clickedSymbole).length > 0 && optionOpen &&
                <div className="tradepopupbox " >
                    <div className="tradebox" onClick={(e) => {
                        if (e.target === e.currentTarget) {
                            setClickedSymbole(null);
                            setOptionOpen(false);
                            setView('')
                        }
                    }}>
                        <div className="tradebox-inner">
                            <SinglePositionSummary positionItem={clickedSymbole} />
                            <div className="trade-cancel">
                                <ul className="tradeui">
                                    {clickedSymbole.type === 'position' ?
                                        <li className="text-red font-12" onClick={() => onTradeCloseModifyClick()}>Close Position</li>
                                        :
                                        <>
                                            <li className="text-red font-12" onClick={() => onRemovePendingClick()}>Remove Pending</li>
                                            <li className="text-blue font-12" onClick={() => onTradeCloseModifyClick(true)}>Modify Pending</li>
                                        </>
                                    }
                                    <li className="font-12" onClick={() => onTradeCloseModifyClick()}>Trade</li>
                                    <li className="font-12" onClick={() => navigateOnChart()}>Chart</li>
                                </ul>
                            </div>
                            <div className="trade-cancel" onClick={() => { setClickedSymbole(null); setOptionOpen(false); setView(''); }}>Cancel</div>
                        </div>
                    </div>
                </div>
            }
            {/* TRADE POPUP END */}

            {posList && posList?.length > 0 && positionBulkOptionOpen &&
                <div className="tradepopupbox " >
                    <div className="tradebox"
                        onClick={() => {
                            // setClickedSymbole({}); 
                            setPositionBulkOptionOpen(false);
                        }}
                    >
                        <div className="tradebox-inner" onClick={(e) => { e.stopPropagation(); e.preventDefault() }}>
                            <div className="trade-main-name bg-tr mb-2">
                                <ul className="trade-name-all ">
                                    <li>
                                        <div className="text-grey font-16 font-bold">Bulk Operations</div>
                                    </li>
                                    <li onClick={() => selectMethodForClosePosition("selected")}>Close Selected</li>
                                    <li onClick={() => selectMethodForClosePosition("closeall")}>Close All Positions</li>
                                    <li onClick={() => selectMethodForClosePosition("closeprofitable")}>Close Profitable Positions</li>
                                    <li onClick={() => selectMethodForClosePosition("closelosing")}>Close Losing Positions</li>
                                </ul>
                            </div>
                            <div className="trade-cancel" onClick={() => { setPositionBulkOptionOpen(false) }}>Cancel</div>
                        </div>
                    </div>
                </div>
            }

            {pendingList?.length > 0 && pendingBulkOptionOpen &&
                <div className="tradepopupbox " >
                    <div className="tradebox"
                        onClick={() => {
                            // setClickedSymbole({}); 
                            setPendingBulkOptionOpen(false);
                        }}
                    >
                        <div className="tradebox-inner" onClick={(e) => { e.stopPropagation(); e.preventDefault() }}>
                            <div className="trade-main-name bg-tr mb-2">
                                <ul className="trade-name-all ">
                                    <li>
                                        <div className="text-grey font-16 font-bold">Bulk Operations</div>
                                    </li>
                                    <li onClick={() => selectMethodForClosePendingOrder("deleteall")}>Delete All Orders</li>
                                    {limitOrStopLength.limitOrderLength?.length > 0 &&
                                        <li onClick={() => selectMethodForClosePendingOrder("deletelimit")}>Delete Limit Orders</li>}
                                    {limitOrStopLength.stopOrderLength?.length > 0 &&
                                        <li onClick={() => selectMethodForClosePendingOrder("deletestop")}>Delete Stop Orders</li>}
                                </ul>
                            </div>
                            <div className="trade-cancel" onClick={() => { setPendingBulkOptionOpen(false) }}>Cancel</div>
                        </div>
                    </div>
                </div>
            }

            {tradeViewIndex === 1 &&
                <TradeComponent backFunction={(obj) => { setTradeViewIndex(obj); setClickedSymbole(null); setSettingView("trade"); }} clientDetails={clientDetails} clickedSymbole={clickedSymbole} setClickedSymbole={setClickedSymbole} />
            }
        </>
    )
}

export default Trade;